// src/utils/validate.js
/**
 * 通用表单校验工具
 * 包含手机号/密码/邮编/身份证等校验规则
 * 所有方法返回 { valid: boolean, msg: string }，纯函数无副作用
 */

// 手机号校验（11位数字，以1开头）
export const validatePhone = (phone) => {
  if (!phone) return { valid: false, msg: '手机号不能为空' };
  const reg = /^1[3-9]\d{9}$/;
  if (!reg.test(phone)) return { valid: false, msg: '请输入有效的手机号' };
  return { valid: true, msg: '' };
};

// 密码复杂度校验（优化版：支持特殊符号，三选二规则）
export const validatePassword = (pwd) => {
  // 1. 非空校验
  if (!pwd) return { valid: false, msg: '密码不能为空' };

  // 2. 长度校验（8-20位）
  if (pwd.length < 8 || pwd.length > 20) {
    return { valid: false, msg: '密码长度需8-20位' };
  }

  // 3. 禁止空白字符（空格、制表符等）
  if (/\s/.test(pwd)) {
    return { valid: false, msg: '密码不能包含空格、制表符等空白字符' };
  }

  // 4. 复杂度校验：字母+数字 / 字母+特殊符号 / 数字+特殊符号（三选二）
  const hasLetter = /[a-zA-Z]/.test(pwd); // 包含字母
  const hasNumber = /\d/.test(pwd);       // 包含数字
  const hasSpecial = /[^a-zA-Z0-9]/.test(pwd); // 包含特殊字符（非字母/数字）

  // 统计满足的类型数量（至少2种）
  const typeCount = [hasLetter, hasNumber, hasSpecial].filter(Boolean).length;
  if (typeCount < 2) {
    return {
      valid: false,
      msg: '密码需包含以下任意两种字符：字母、数字、特殊符号（@!#$%^&*等）'
    };
  }

  // 校验通过
  return { valid: true, msg: '' };
};

// 验证码校验（6位数字）
export const validateSmsCode = (code) => {
  if (!code) return { valid: false, msg: '验证码不能为空' };
  const reg = /^\d{6}$/;
  if (!reg.test(code)) return { valid: false, msg: '请输入6位数字验证码' };
  return { valid: true, msg: '' };
};

// 邮编校验（6位数字）
export const validatePostalCode = (code) => {
  if (!code) return { valid: true, msg: '' }; // 非必填
  const reg = /^\d{6}$/;
  if (!reg.test(code)) return { valid: false, msg: '请输入6位数字邮政编码' };
  return { valid: true, msg: '' };
};

// 身份证号校验（简单版，18位）
export const validateIdCard = (idCard) => {
  if (!idCard) return { valid: true, msg: '' }; // 非必填
  const reg = /^\d{17}[\dXx]$/;
  if (!reg.test(idCard)) return { valid: false, msg: '请输入有效的18位身份证号' };
  return { valid: true, msg: '' };
};

// 姓名校验（2-10个中文字符）
export const validateRealName = (name) => {
  if (!name) return { valid: false, msg: '姓名不能为空' };
  const reg = /^[\u4e00-\u9fa5]{2,10}$/;
  if (!reg.test(name)) return { valid: false, msg: '请输入2-10个中文字符的真实姓名' };
  return { valid: true, msg: '' };
};

// 详细地址校验
export const validateAddress = (address) => {
  if (!address) return { valid: false, msg: '详细地址不能为空' };
  if (address.length < 5) return { valid: false, msg: '详细地址不能少于5个字符' };
  return { valid: true, msg: '' };
};
